import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const BREADCRUMBS_CLASS_NAME = 'Breadcrumbs';
export const BREADCRUMBS_CLASS_SLOTS = ['root', 'list'] as const;

export type BreadcrumbsClassSlot = (typeof BREADCRUMBS_CLASS_SLOTS)[number];

export interface BreadcrumbsClasses {
	root: string;
	list: string;
}

export type BreadcrumbsClassKey = keyof BreadcrumbsClasses;

export const getBreadcrumbsUtilityClass = (slot: string) =>
	generateUtilityClass(BREADCRUMBS_CLASS_NAME, slot);

export const breadcrumbsClasses: BreadcrumbsClasses = generateUtilityClasses(
	BREADCRUMBS_CLASS_NAME,
	['root', 'list'],
);

export default breadcrumbsClasses;
